import React from "react";

export default function Hamburger() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="15.508" height="11.75">
			<g data-name="Group 441" fill="none" stroke="#fff" strokeWidth="2">
				<path data-name="Line 102" d="M.008 1h15.5" />
				<path data-name="Line 103" d="M.008 5.825h15.5" />
				<path data-name="Line 104" d="m.008 10.65 12 .1" />
			</g>
		</svg>
	);
}
